import { cn } from "@/lib/utils";

/** Monograma "n" no acento + nome "nora" (o nome some com `compact`). Decorativo quando há texto ao lado. */
export function Logo({
  compact = false,
  onAccent = false,
  className,
}: {
  compact?: boolean;
  /** Sobre fundo no acento (ex.: painel do login): monograma translúcido e texto claro. */
  onAccent?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn("inline-flex items-center gap-2.5", onAccent ? "text-accent-ink" : "text-ink", className)}
    >
      <svg viewBox="0 0 36 36" className="size-9 shrink-0" aria-hidden="true">
        <rect width="36" height="36" rx="11" className={onAccent ? "fill-accent-ink/15" : "fill-accent"} />
        <path
          d="M12 26V14.5h3.2v1.9c.9-1.5 2.4-2.2 4.2-2.2 2.9 0 4.6 1.9 4.6 5V26h-3.3v-6.2c0-1.7-.9-2.7-2.4-2.7-1.6 0-2.9 1.1-2.9 3.1V26Z"
          className="fill-accent-ink"
        />
      </svg>
      {!compact && <span className="text-[22px] font-bold tracking-[-0.03em]">nora</span>}
    </span>
  );
}
